<div class="tab-container mat-typography">
  <router-outlet>
    <h3>{{ 'labels.heading.Family Members' | translate }}</h3>

    <div class="layout-row align-flex-end">
      <button mat-raised-button color="primary" [routerLink]="['./add']">
        <fa-icon icon="plus" class="m-r-10"></fa-icon>{{ 'labels.buttons.Add' | translate }}
      </button>
    </div>

    <mat-accordion>
      @for (member of clientFamilyMembers; track member; let i = $index) {
        <mat-expansion-panel class="family-member">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ displayName(member) }}
            </mat-panel-title>
            <mat-panel-description>
              {{ member.relationship }}
            </mat-panel-description>
          </mat-expansion-panel-header>
          <mat-divider [inset]="true"></mat-divider>
          <div class="family-member-actions layout-row align-end">
            <button mat-button color="primary">
              <fa-icon icon="edit" [routerLink]="[member.id, 'edit']"></fa-icon>
            </button>
            <button
              mat-button
              color="warn"
              (click)="deleteFamilyMember(member.clientId, member.id, member.firstName, i)"
            >
              <fa-icon icon="trash"></fa-icon>
            </button>
          </div>
          <p>
            @if (member.firstName) {
              <span>{{ 'labels.inputs.First Name' | translate }} : {{ member.firstName }}<br /></span>
            }
            @if (member.middleName) {
              <span>{{ 'labels.inputs.Middle Name' | translate }} : {{ member.middleName }}<br /></span>
            }
            @if (member.lastName) {
              <span>{{ 'labels.inputs.Last Name' | translate }} : {{ member.lastName }}<br /></span>
            }
            @if (member.qualification) {
              <span>{{ 'labels.inputs.Qualification' | translate }} : {{ member.qualification }}<br /></span>
            }
            @if (member.mobileNumber) {
              <span>{{ 'labels.inputs.Mobile Number' | translate }} : {{ member.mobileNumber }}<br /></span>
            }
            @if (member.age) {
              <span>{{ 'labels.inputs.Age' | translate }} : {{ member.age }}<br /></span>
            }
            @if (member.isDependent) {
              <span>{{ 'labels.inputs.Is Dependent' | translate }} : {{ member.isDependent | yesNo }}<br /></span>
            }
            @if (member.maritalStatus) {
              <span>{{ 'labels.inputs.Marital Status' | translate }} : {{ member.maritalStatus }}<br /></span>
            }
            @if (member.gender) {
              <span>{{ 'labels.inputs.Gender' | translate }} : {{ member.gender }}<br /></span>
            }
            @if (member.profession) {
              <span>{{ 'labels.inputs.Profession' | translate }} : {{ member.profession }}<br /></span>
            }
            @if (member.dateOfBirth) {
              <span>{{ 'labels.inputs.Date Of Birth' | translate }} : {{ member.dateOfBirth | dateFormat }}<br /></span>
            }
          </p>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </router-outlet>
</div>
